// Copyright (c) Move Closer 2022.

import { Model, Token as AuthToken } from '@movecloser/front-core'

import { IToken, TokenData } from '../contracts/models'

/**
 * @author Wojciech Falkowski <wojciech.falkowski@movecloser.pl>
 */
export class Token extends Model<TokenData> implements IToken {
  protected boot (): void {
    this.initialValues = {
      tokenType: 'Bearer',
      expiresIn: null
    }
    this.modelProperties = [
      'accessToken',
      'tokenType',
      'expiresAt'
    ]
  }

  public toAuthToken (): AuthToken {
    return {
      accessToken: this._data.accessToken,
      expiresAt: this._data.expiresAt,
      tokenType: this._data.tokenType
    }
  }
}
